// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2nj_Q","footer":"ModalFilter_footer__N2YWf"};